<template>
    <div :class="{warning}">
        {{ text }}
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class TooltipHeader extends Vue {
        @Prop({type: String, required: true}) public text!: string;
        @Prop({type: Boolean}) public warning!: boolean;
    }
</script>

<style lang="scss" scoped>
    div {
        display: block;
        margin-bottom: 8px;
        font-weight: 700;
        background: var(--header-bar-background-color);
        color: var(--header-bar-text-color);
        padding: 8px;

        &.warning {
            background: var(--atw-issues-marker-color);
            color: var(--main-background-color);
        }
    }
</style>
